<template>
  <section class="">
     <div class="gallery-header">
        <div class="gallery-header-left">
          <div aria-label="Fan Logo" class="logo icon-fan-logo"></div>
          <div class="description">{{options.GalleryTitle}}</div>
        </div>

        <button tabindex="0" @click="unSetCurrentImage(); scrollToImage();" class="close" :aria-label="options.Close">
        </button>
      </div>
      <div class="gallery-mediaview-track" :class="{ 'isvideo': currentItem.IsVideo }">
        <transition :name="`gallery-slide-${slideDirection}`">
          <div
            v-if="currentItem"
            :key="currentItem.Id"
            class="gallery-mediaview-wrapper"
          >
            <div class="gallery-mediaview">
                <picture
                  v-if="!currentItem.IsVideo"
                  class="image-wrapper"
                  v-lazyload="{
                    src: `${currentItem.ImageSrc}`,
                    set: [
                      { height: 1000},
                    ],
                    fit: 'crop',
                    align: 'center'
                  }"
                >
                    <img
                      class="image"
                      src="data:image/gif;base64,R0lGODlhAQABAIAAAP///wAAACH5BAEAAAAALAAAAAABAAEAAAICRAEAOw=="
                      v-bind:alt="currentItem.Title"
                    />
                </picture>
                <video-player
                  v-if="currentItem.IsVideo"
                  class=""
                  :desktop-video="currentItem.DesktopVideo"
                  :desktop-video-poster-image="currentItem.DesktopVideoPosterImage !== '' ? currentItem.DesktopVideoPosterImage : options.GalleryMissingImage"
                  :is-background-video="false"
                  :dictionary="videoPlayerDictionary"
                  :alt-text="currentItem.Title"
                  >
                </video-player>
            </div>
            <div v-if="currentItem.Title.length" class="gallery-mediaview-info">
              <div class="gallery-item-title">{{currentItem.Title}}</div>
              <div
                v-if="currentItem.ShortDescription.length"
                class="gallery-item-description"
              >
                {{currentItem.ShortDescription}}
              </div>
              <div
                v-if="currentItem.CtaUrl.length"
                class="gallery-item-cta"
              >
                <a
                  :href="currentItem.CtaUrl"
                  :target="currentItem.CtaTarget"
                  v-html="currentItem.CtaText != '' ? currentItem.CtaText : options.LearnMore"
                />

              </div>
            </div>
          </div>
        </transition>
      </div>
    <div class="gallery-arrows-wrapper">
      <button tabindex="0" :aria-label="`${options.Previous} ${previousItemNumber}/${totalImages} ${previousItem.Title}`" @click="goToPrev" class="gallery-imageview-arrows gallery-imageview-prev"></button>
      <div tabindex="0" :aria-label="`${currentItemNumber}/${totalImages}`" class="pagination">{{currentItemNumber}}/{{totalImages}}</div>
      <button tabindex="0" :aria-label="`${options.Next} ${nextItemNumber}/${totalImages} ${nextItem.Title}`" @click="goToNext" class="gallery-imageview-arrows gallery-imageview-next"></button>
    </div>
  </section>
</template>

<script>
import TabTrapMixin from '@mixins/tab-trap'
import { mapState } from 'vuex'

export default {
  name: 'gallery-carousel',
  props: {
    items: {
      type: Array,
      default: () => []
    },
    options: {
      type: Object,
      required: true
    },
  },
  mixins: [TabTrapMixin],
  data: () => ({
    slideDirection: 'left',
    imageIndex: null
  }),
  inject: ['videoPlayerDictionary'],
  computed: {
    ...mapState('responsive', { vHeight: 'height' }),
    totalImages() {
      return this.items.length
    },
    currentImageIndex() {
      const index = Number(this.$route.query.imageIndex);
      if (isNaN(index) || index < 1 || index > this.items.length) {
        return 0;
      }
      return index - 1;
    },
    currentItem() {
      return this.items[this.currentImageIndex];
    },
    previousItem() {
      const index = this.getWrappedIndex(this.currentImageIndex - 1);
      return this.items[index];
    },
    nextItem() {
      const index = this.getWrappedIndex(this.currentImageIndex + 1);
      return this.items[index];
    },
    currentItemNumber() {
      return this.currentImageIndex + 1;
    },
    previousItemNumber() {
      return this.getWrappedIndex(this.currentImageIndex - 1) + 1;
    },
    nextItemNumber() {
      return this.getWrappedIndex(this.currentImageIndex + 1) + 1;
    }
  },
  mounted() {
    window.addEventListener('keydown', this.keyEvent)
    this.imageIndex = this.currentImageIndex
  },
  destroyed() {
    window.removeEventListener('keydown', this.keyEvent)
  },
  methods: {
    getWrappedIndex(index) {
      return (index + this.items.length) % this.items.length;
    },
    goToPrev() {
      this.slideDirection = 'right';
      this.goToIndex(this.getWrappedIndex(this.currentImageIndex - 1));
    },
    goToNext() {
      this.slideDirection = 'left';
      this.goToIndex(this.getWrappedIndex(this.currentImageIndex + 1));
    },
    goToIndex(index) {
      this.imageIndex = index
      this.$router.push({
        query: {
          ...this.$route.query,
          imageIndex: index + 1
        }
      })
    },
    unSetCurrentImage() {
      this.$emit('close')
    },
    scrollToImage() {
      this.$emit('scroll', { imageIndex: this.imageIndex, behavior: 'instant' })
    },
    keyEvent(e){
     if (e.keyCode == 27) {
        //Escape
        this.$emit('close')
      }
    },
  }
}
</script>
